import appConfig from "../../config/app_config.js"; 

export default class WizardMessageObject {

    static _eventSavedMessagesRequestObject(
        eventId,
        startTime = null,
        endTime = null
      ) {
        let retObj = {
          EventId: eventId,
          Fields: {}
        };
    
        return retObj;
      }

  static _saveMessageObject(messageData) {
    if (messageData.Time.length != 4 && messageData.Time.charAt(2) !== ":" || messageData.Time.charAt(0) > "2" || (messageData.Time.charAt(0) == "2" && messageData.Time.charAt(1) >= "4")) {
      window.EventBus.fire("inputDialog");
      return null;
    }

    if (
        messageData.Time.charAt(2) == "6" ||
        messageData.Time.charAt(2) == "7" ||
        messageData.Time.charAt(2) == "8" ||
        messageData.Time.charAt(2) == "9" ||
        messageData.Time.length > 5
    ) {
      window.EventBus.fire("inputDialog");
      return null;
    }
    if (messageData.Time.charAt(2) !== ":") {
        messageData.Time = messageData.Time.slice(0, 2) + ":" + messageData.Time.slice(2, 4);
      console.log("the new time is ", messageData.Time);
    }
    console.log("_saveSingleMessageObject object", messageData);
    if (messageData.Date == null) throw "Date parameter is missing";
    
    let dateTime =
    messageData.Date
        .split("-")
        .reverse()
        .join("-") +
      " " +
      messageData.Time;

     
    if (messageData.ToEventSubscribers == null ) {
        messageData.ToEventSubscribers = 0;
    }

    if (!messageData.hasOwnProperty('PromoCode')) {
        messageData.PromoCode = "";
    }
    if (!messageData.hasOwnProperty('Tags')) {
        messageData.Tags = {};
    }
    
    let reqObj = {};
    if (messageData.hasOwnProperty('UnitId')) {
      reqObj = {
        EventId: messageData.EventId,
        Title: messageData.Title,
        Text: messageData.Text,
        PromoCode: messageData.PromoCode,
        DateTime: dateTime,
        ToEventSubscribers: messageData.ToEventSubscribers,
        Tags: messageData.Tags,
        UserGroup: appConfig.dss.environmentName,
        UnitId: messageData.UnitId
      };
    } else {
    reqObj = {
      EventId: messageData.EventId,
      Title: messageData.Title,
      Text: messageData.Text,
      PromoCode: messageData.PromoCode,
      DateTime: dateTime,
      ToEventSubscribers: messageData.ToEventSubscribers,
      Tags: messageData.Tags,
      UserGroup: appConfig.dss.environmentName
    };
  }
    return reqObj;
  }
}
